<template>
  <page></page>
</template>

<script>
// @ is an alias to /src
import page from '@/components/page/page'     //公共组件page  页面
export default {
  name: 'home',
  components: {
    page
  }
};
</script>
